// « Nouvel éditeur mobile » — shared pieces of the top bar and the tab bar.

export type M2SaveStatus = 'idle' | 'saving' | 'saved' | 'error';

export function saveStatusLabel(status: M2SaveStatus, everSaved: boolean): string {
  if (status === 'saving') return 'Enregistrement…';
  if (status === 'error') return 'Non enregistré';
  if (status === 'saved' || everSaved) return 'Enregistré';
  return '';
}

export type M2Tab = 'pages' | 'photos' | 'text' | 'layout' | 'cover';

export const M2_TABS: { key: M2Tab; label: string; icon: React.ReactNode }[] = [
  {
    key: 'pages',
    label: 'Pages',
    icon: (<><rect x="3" y="4" width="7" height="16" rx="1" /><rect x="14" y="4" width="7" height="16" rx="1" /></>),
  },
  {
    key: 'photos',
    label: 'Photos',
    icon: (<><rect x="3" y="4" width="18" height="16" rx="2" /><circle cx="9" cy="10" r="2" /><path d="M21 16l-5-5-9 9" /></>),
  },
  {
    key: 'text',
    label: 'Texte',
    icon: (<path d="M5 6h14M12 6v13M9 19h6" />),
  },
  {
    key: 'layout',
    label: 'Mise en page',
    icon: (<><rect x="4" y="4" width="16" height="16" rx="1" /><path d="M4 12h16M12 12v8" /></>),
  },
  {
    key: 'cover',
    label: 'Couverture',
    icon: (<><path d="M6 3h11a2 2 0 012 2v16H6a2 2 0 01-2-2V5a2 2 0 012-2z" /><path d="M8 3v18" /></>),
  },
];

